window.HealthyEating = (function ($) {
    let elements = null;
    let gtm = null;
    document.addEventListener('DOMContentLoaded', function (){
        elements = window.HealthyEatingConstants.elements;
        gtm = window.HealthyEatingGtm;
    });
    const self = {
        authenticated: true,
        urls: {
            checkAuthentication: '/api/sitecore/MemberAuthentication/AuthenticationStateCheck',
            enrolment: '/api/sitecore/SignUp/Submit',
            bankDetails: '/api/sitecore/SignUp/CheckBankDetails',
            delink: '/api/sitecore/Delinking/DelinkAccount',
            ajax: function (type, url, data, success, error, complete) {
                if (data === undefined) {
                    $.ajax({
                        type: type,
                        url: url,
                        success: success,
                        error: error,
                        complete: complete
                    });
                } else {
                    $.ajax({
                        type: type,
                        dataType: 'json',
                        url: url,
                        contentType: 'application/json',
                        data: data,
                        success: success,
                        error: error,
                        complete: complete
                    });
                }
            }
        },
        func: {
            init: function () {
                self.func.bindings();
                gtm.gtm();
                self.func.loadValues();
                self.func.buildDisplay();
            },
            bindings: function () {
                $(elements.forms.sectionOne).on('submit', self.func.stepOne.submit);
                $(elements.forms.sectionTwo).on('submit', self.func.stepTwo.submit);
                $(elements.buttons.stepTwoBack).on('click', self.func.stepTwo.back);
                $(elements.forms.sectionThree).on('submit', self.func.stepThree.submit);
                $(elements.buttons.stepThreeBack).on('click', self.func.stepThree.back);
                $(elements.ids.membershipNo).on('change', self.func.helpers.validate);
                $(elements.buttons.stepTwoNext).on('click', gtm.stepTwo.submit);
                $(elements.buttons.stepTwoNext).on('click', self.func.stepTwo.showSurnameModal);
                $(elements.buttons.detailsCancel).on('click', gtm.stepTwo.confirmDetails.cancel);
                $(elements.buttons.detailsConfirm).on('click', gtm.stepTwo.confirmDetails.confirm);
                $(elements.ids.closeSurnameModalBtn).on('click', self.func.stepTwo.closeSurnameModal);
                $(elements.ids.membershipNo).on(
                    'input keydown keyup mousedown mouseup select contextmenu drop',
                    self.func.helpers.inputCheck);
                $(elements.ids.reviewMembershipNoInput).on('change', self.func.helpers.reviewMembershipNoChange);
                $(elements.ids.reviewMembershipNoInput).on(
                    'input keydown keyup mousedown mouseup select contextmenu drop',
                    self.func.helpers.inputCheck);
                $(elements.buttons.failurePageReload).on('click', self.func.helpers.resetReload);
                $(elements.input.noCard).on('click',
                    function () {
                        self.func.helpers.disableButton(elements.buttons.stepOneNext);
                    });
                $(elements.input.yesCard).on('click',
                    function () {
                        self.func.helpers.enableButton(elements.buttons.stepOneNext);
                    });
                $(elements.buttons.delinkButton).on('click', self.func.delink.prompt);
                $(elements.buttons.delinkConfirm).on('click', self.func.delink.confirm);
                $(elements.buttons.reviewMembershipNoUpdate).on('click', self.func.helpers.updateReviewMembershipNo);
            },
            loadValues: function () {
                self.func.clearStorage();
                sessionStorage.setItem(elements.sessionStorage.currentStep, elements.steps.sectionOne);
                self.func.stepOne.show();
            },
            clearStorage: function () {
                sessionStorage.removeItem(elements.sessionStorage.membershipNo);
                sessionStorage.removeItem(elements.sessionStorage.currentStep);
            },
            buildDisplay: function () {
                const currentStep = sessionStorage.getItem(elements.sessionStorage.currentStep) || elements.steps.sectionOne;
                switch (currentStep) {
                    case elements.steps.sectionOne:
                        self.func.stepOne.show();
                        break;
                    case elements.steps.sectionTwo:
                        self.func.stepTwo.show();
                        break;
                    case elements.steps.sectionThree:
                        self.func.stepThree.show();
                        break;
                    case elements.steps.sectionFour:
                        self.func.stepFour.show();
                        break;
                    default:
                        self.func.helpers.showStep(elements.steps.failureSection);
                }
            },
            stepOne: {
                submit: function (event) {
                    event.preventDefault();
                    if (self.func.stepOne.validate()) {
                        const oldMembershipNo = sessionStorage.getItem(elements.sessionStorage.membershipNo);
                        sessionStorage.setItem(elements.sessionStorage.membershipNo, $(elements.ids.membershipNo).val());
                        self.func.helpers.updateMembershipNoTag(elements.ids.reviewMembershipNo, oldMembershipNo);
                        sessionStorage.setItem(elements.sessionStorage.currentStep, elements.steps.sectionTwo);
                        gtm.stepOne.submit();
                        self.func.stepTwo.show();
                        self.func.helpers.scrollToTop();
                    }
                },
                show: function () {
                    self.func.helpers.stepDetails(elements.steps.sectionOne,
                        '1',
                        elements.constants.sectionOneTitle,
                        elements.constants.sectionZeroTitle,
                        elements.constants.sectionTwoTitle
                    );
                },
                validate: function () {
                    return self.func.helpers.validateMembershipBox($(elements.ids.membershipNo)) &
                        self.func.helpers.validateCheckbox(elements.ids.memberCheckboxId, elements.ids.memberCheckboxPrompt) &
                        self.func.helpers.validateCheckbox(elements.ids.bankCheckbox, elements.ids.bankCheckboxPrompt);
                }
            },
            stepTwo: {
                showSurnameModal: function () {
                    $(elements.ids.waitroseSurnameModal).show();
                },
                closeSurnameModal: function () {
                    $(elements.ids.waitroseSurnameModal).hide();
                },
                submit: function (event) {
                    event.preventDefault();
                    sessionStorage.setItem(elements.sessionStorage.currentStep, elements.steps.sectionThree);
                    self.func.helpers.updateMembershipNoInput(elements.ids.reviewMembershipNoInput);
                    self.func.stepThree.show();
                    self.func.helpers.scrollToTop();
                },
                back: function (event) {
                    event.preventDefault();
                    sessionStorage.setItem(elements.sessionStorage.currentStep, elements.steps.sectionOne);
                    self.func.stepOne.show();
                    self.func.helpers.scrollToTop();
                },
                show: function () {
                    self.func.helpers.stepDetails(elements.steps.sectionTwo,
                        '2',
                        elements.constants.sectionTwoTitle,
                        elements.constants.sectionOneTitle,
                        elements.constants.sectionThreeTitle
                    );
                }
            },
            stepThree: {
                submit: function (event) {
                    event.preventDefault();
                    self.func.helpers.disableButton(elements.buttons.stepThreeNext);
                    const action = function () {
                        const membershipNo = sessionStorage.getItem(elements.sessionStorage.membershipNo);
                        const data = '{ waitroseAccNo: ' + membershipNo + ' }';
                        if (self.func.stepThree.validate()) {
                            self.urls.ajax(
                                'POST',
                                self.urls.enrolment,
                                data,
                                self.func.stepThree.success,
                                self.func.stepThree.error
                            );
                        } else {
                            self.func.helpers.enableButton(elements.buttons.stepThreeNext);
                            gtm.stepThree.submit();
                        }
                    };

                    self.func.helpers.checkAuthentication(action);
                },
                success: function (data) {
                    if (data.Successful) {
                        sessionStorage.setItem(elements.sessionStorage.currentStep, elements.steps.sectionFour);
                        gtm.stepThree.success();
                        self.func.stepFour.show();
                        self.func.helpers.scrollToTop();
                    } else {
                        gtm.stepThree.successError(data);
                        self.func.helpers.showSignupFailureErrorMessage(data.ErrorTitle, data.ErrorDescription);
                        self.func.helpers.showStep(elements.steps.failureSection);
                        self.func.helpers.scrollToTop();
                    }
                    self.func.helpers.enableButton(elements.buttons.stepThreeNext);
                    self.func.helpers.clearSessionStorage();
                },
                error: function (jqXHR, textStatus) {
                    gtm.stepThree.error(jqXHR, textStatus);
                    self.func.helpers.clearSessionStorage();
                    self.func.helpers.redirectToErrorPage();
                },
                back: function (event) {
                    event.preventDefault();
                    sessionStorage.setItem(elements.sessionStorage.currentStep, elements.steps.sectionTwo);
                    self.func.stepTwo.show();
                    self.func.helpers.scrollToTop();
                },
                show: function () {
                    self.func.helpers.stepDetails(elements.steps.sectionThree,
                        '3',
                        elements.constants.sectionThreeTitle,
                        elements.constants.sectionTwoTitle,
                        elements.constants.sectionFourTitle
                    );
                },
                validate: function () {
                    return self.func.helpers.validateMembershipBox($(elements.ids.reviewMembershipNoInput)) &
                        self.func.helpers.validateCheckbox(elements.ids.termsCheckbox, elements.ids.termsPrompt) &
                        self.func.helpers.validateCheckbox(elements.ids.dataShareCheckbox, elements.ids.dataSharePrompt) &
                        self.func.helpers.validateCheckbox(elements.ids.reviewCheckBoxYes, elements.ids.reviewConfirmationWarningMessage);
                }
            },
            stepFour: {
                show: function () {
                    self.func.helpers.showStep(elements.steps.sectionFour);
                    const pageNumber = '4';
                    self.func.helpers.updateProgressBar(
                        elements.constants.sectionFourTitle,
                        pageNumber,
                        elements.constants.sectionThreeTitle,
                        ''
                    );
                }
            },
            delink: {
                prompt: function () {
                   window.openModal(elements.ids.delinkModal);
                },
                confirm: function (event) {
                    event.preventDefault();
                    self.func.helpers.disableButton(elements.buttons.delinkConfirm);
                    const action = function () {
                        self.urls.ajax(
                            'POST',
                            self.urls.delink,
                            undefined,
                            self.func.delink.success,
                            self.func.delink.error
                        );
                    };
                    self.func.helpers.checkAuthentication(action);
                },
                success: function (data) {
                    if (data.Successful) {
                        gtm.delink.success();
                        self.func.helpers.enableButton(elements.buttons.delinkConfirm);
                        window.closeModal(elements.ids.delinkModal);
                        self.func.helpers.reloadPage();
                    } else {
                        gtm.delink.successFail(data);
                        self.func.helpers.enableButton(elements.buttons.delinkConfirm);
                        window.closeModal(elements.ids.delinkModal);
                        self.func.helpers.showDelinkFailureErrorNotification();
                        self.func.helpers.scrollToTop();
                        self.func.helpers.show(elements.ids.delinkFailedErrorNotification);
                    }
                },
                error: function (jqXHR, textStatus) {
                    gtm.delink.error(jqXHR, textStatus)
                    self.func.helpers.redirectToErrorPage();
                }
            },
            helpers: {
                stepDetails: function (stepToShow, pageNumber, sectionTitleOne, sectionTitleTwo, sectionTitleThree) {
                    self.func.helpers.showStep(stepToShow);
                    self.func.helpers.updateProgressBar(
                        sectionTitleOne,
                        pageNumber,
                        sectionTitleTwo,
                        sectionTitleThree
                    );
                },
                resetReload: function () {
                    self.func.helpers.clearSessionStorage();
                    self.func.helpers.reloadPage();
                },
                scrollToTop: function () {
                    const speed = 500;
                    $('html, body').animate({
                        scrollTop: 0
                    },
                        speed);
                },
                clearSessionStorage: function () {
                    sessionStorage.clear();
                },
                showStep: function (step) {
                    self.func.helpers.clearSteps();
                    if (step === elements.steps.sectionOne ||
                        step === elements.steps.sectionTwo ||
                        step === elements.steps.sectionThree) {
                        self.func.helpers.show(elements.ids.formParent);
                    }
                    self.func.helpers.show(step);
                },
                updateProgressBar: function (title, pageNumber, back, next) {
                    $(elements.progressBarIds.progressTitle).text(title);
                    $(elements.progressBarIds.progressNext).text('Next: ' + next);
                    $(elements.progressBarIds.progressBack).text('Back: ' + back);
                    $(elements.progressBarIds.progressText)
                        .text(pageNumber + ' of ' + elements.constants.maxPage);
                    const percentageFactor = 100;
                    const progressWidth = Math.floor((pageNumber / elements.constants.maxPage) * percentageFactor);
                    $(elements.progressBarIds.progressBar).width(progressWidth + '%');
                },
                clearSteps: function(){
                    const steps = elements.steps
                    const ids = [steps.sectionOne, steps.sectionTwo, steps.sectionThree, steps.failureSection,
                    steps.sectionFour, elements.ids.formParent];
                    for (let i = 0; i < ids.length; i++) {
                        if ($(ids[i]).is(':visible')) {
                            self.func.helpers.hide(ids[i]);
                        }
                    }
                },
                reloadPage: function () {
                    location.reload(true);
                },
                inputCheck: function (e) {
                    const el = e.currentTarget;
                    if (/[^0-9]/.test($(el).val())) {
                        $(el).val($(el).data('oldvalue'));
                    } else {
                        $(el).data('oldvalue', $(el).val());
                    }
                },
                validate: function (e) {
                    const el = e.currentTarget;
                    self.func.helpers.validateMembershipBox($(el));
                },
                validateMembershipBox: function (e) {
                    const value = e.val();
                    const membershipNoInputs = $(elements.ids.formParent).find(elements.classes.membershipNo);
                    if (membershipNoInputs.hasClass(elements.classes.inputBoxInvalid)) {
                        $(elements.ids.formParent)
                            .find(elements.classes.membershipNo)
                            .removeClass(elements.classes.inputBoxInvalid);
                    }
                    const correctLength = 16;
                    if (value.length > correctLength) {
                        self.func.helpers.show(elements.classes.formParentNumberTooLong);
                        self.func.helpers.hide(elements.classes.formParentNumberTooShort);
                        self.func.helpers.hide(elements.classes.formParentLuhnCheckFail);
                        $(elements.ids.formParent).find(elements.classes.membershipNo).addClass(elements.classes.inputBoxInvalid);
                        gtm.memberNumber.overMaxLength();
                        return false;
                    } else if (value.length < correctLength) {
                        self.func.helpers.hide(elements.classes.formParentNumberTooLong);
                        self.func.helpers.hide(elements.classes.formParentLuhnCheckFail);
                        self.func.helpers.show(elements.classes.formParentNumberTooShort);
                        $(elements.ids.formParent).find(elements.classes.membershipNo).addClass(elements.classes.inputBoxInvalid);
                        gtm.memberNumber.tooShort();
                        return false;
                    } else {
                        self.func.helpers.hide(elements.classes.formParentNumberTooLong);
                        self.func.helpers.hide(elements.classes.formParentNumberTooShort);
                    }
                    const split = value.split('');
                    let sum = 0;
                    const ten = 10;
                    let isDoubled = false;
                    $.each(split.reverse(), function(_index, digit) {
                        let loDigit = digit;
                        const number = 2;
                        if (isDoubled) {
                            loDigit *= number;
                        }
                        sum += Math.floor(loDigit / ten) + (loDigit % ten);
                        isDoubled = !isDoubled;
                    });
                    const result = (sum % ten === 0);
                    if (!result) {
                        self.func.helpers.show(elements.classes.formParentLuhnCheckFail);
                        $(elements.ids.formParent).find(elements.classes.membershipNo).addClass(elements.classes.inputBoxInvalid);
                        gtm.memberNumber.wrongNumber();
                        return false;
                    } else {
                        self.func.helpers.hide(elements.classes.formParentLuhnCheckFail);
                    }
                    return true;
                },
                validateCheckbox: function (checkbox, prompt){
                    if($(checkbox).is(':visible')) {
                        self.func.helpers.hide(prompt, elements.classes.itemRemoved)
                        let validationResult = true;
                        if ($(checkbox).is(':checked') === false) {
                            self.func.helpers.show(prompt);
                            validationResult = false;
                        }
                        return validationResult;
                    } else {
                        return true;
                    }
                },
                checkAuthentication: function (onSuccess) {
                    const complete = function (jqXHR) {
                        if (jqXHR.status === window.HealthyEatingConstants.httpStatusCode.ok) {
                            onSuccess();
                        } else if (jqXHR.status === window.HealthyEatingConstants.httpStatusCode.loginTimeout) {
                            self.func.helpers.resetReload();
                        } else {
                            self.func.helpers.redirectToErrorPage();
                        }
                    };
                    self.urls.ajax('GET', self.urls.checkAuthentication, undefined, undefined, undefined, complete);
                },
                redirectToErrorPage: function () {
                    window.location.replace($(elements.ids.errorPage).val());
                },
                disableButton: function (buttonElement) {
                    if ($(buttonElement).hasClass(elements.classes.buttonEnabled)) {
                        $(buttonElement).removeClass(elements.classes.buttonEnabled);
                    }
                    if (!$(buttonElement).hasClass(elements.classes.buttonDisabled)) {
                        $(buttonElement).addClass(elements.classes.buttonDisabled);
                    }
                },
                enableButton: function (buttonElement) {
                    if ($(buttonElement).hasClass(elements.classes.buttonDisabled)) {
                        $(buttonElement).removeClass(elements.classes.buttonDisabled);
                    }
                    if (!$(buttonElement).hasClass(elements.classes.buttonEnabled)) {
                        $(buttonElement).addClass(elements.classes.buttonEnabled);
                    }
                },
                showSignupFailureErrorMessage: function (title, description) {
                    $(elements.ids.signupFailureTitle).html(title);
                    $(elements.ids.signupFailureDescription).html(description);
                },
                showDelinkFailureErrorNotification: function () {
                    self.func.helpers.show(elements.ids.delinkFailedErrorNotification);
                },
                updateMembershipNoTag: function (id, oldMembershipNo) {
                    const membershipNo = sessionStorage.getItem(elements.sessionStorage.membershipNo);
                    $(id).text($(id).text().replace(elements.constants.membershipNoTag, membershipNo));
                    if (oldMembershipNo != null) {
                        $(id).text($(id).text().replace(oldMembershipNo, membershipNo));
                    }
                },
                updateMembershipNoInput: function (id) {
                    const membershipNo = sessionStorage.getItem(elements.sessionStorage.membershipNo);
                    $(id).text($(id).text().replace(elements.constants.membershipNoTag, membershipNo));
                    $(id).attr('placeholder', membershipNo);
                    $(id).val(membershipNo);
                },
                updateReviewMembershipNo: function () {
                    const oldMembershipNo = sessionStorage.getItem(elements.sessionStorage.membershipNo);
                    const number = $(elements.ids.reviewMembershipNoInput).val();
                    if (self.func.helpers.validateMembershipBox($(elements.ids.reviewMembershipNoInput))) {
                        sessionStorage.setItem(elements.sessionStorage.membershipNo,
                            number);
                        self.func.helpers.updateMembershipNoTag(elements.ids.reviewMembershipNo, oldMembershipNo);
                        if ($(elements.ids.reviewMembershipNoListItem).hasClass(elements.classes.listItemEditState)) {
                            $(elements.ids.reviewMembershipNoListItem).removeClass(elements.classes.listItemEditState);
                        }
                    }
                },
                reviewMembershipNoChange: function (e) {
                    self.func.helpers.validate(e);
                    $(elements.ids.membershipNo).val($(elements.ids.reviewMembershipNoInput).val());
                }, //Shows an item
                hide: function(identifier) {
                    $(identifier).addClass(elements.classes.itemRemoved);
                }, //Shows an item
                show: function(identifier) {
                    $(identifier).removeClass(elements.classes.itemRemoved);
                }
            }
        }
    };
    return {
        Init: self.func.init
    };
})(jQuery);

$('document').ready(function () {
    if ('waitrose' === $('#page-data').data('feature')) {
        window.HealthyEating.Init();
    }
});
